export const Reviews = () => {
  return (
    <section data-testid="reviews-section" className="py-16 max-w-6xl mx-auto px-6 border-t border-ink/10">
      <div className="p-8 md:p-12 rounded-3xl bg-cream border border-ink/10 text-center space-y-3">
        <h3 className="font-display text-2xl font-normal">Cosa dicono le nostre clienti</h3>
        <p data-testid="reviews-empty-state" className="text-xs text-ink/60 italic">
          Le recensioni delle prime clienti online appariranno qui presto.
        </p>
      </div>
    </section>
  );
};
